import { FC } from 'react';
import RcUpload from 'rc-upload';
interface UploadProps {
  style?: React.CSSProperties;
  className?: string;
  [key: string]: any;
}
export const Upload: FC<UploadProps> = ({
  style = {},
  className = '',
  headers = {},
  ...rest
}) => {
  return <RcUpload className={className} style={style} {...rest} />;
};
